import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { TextCarousel } from '../TextCarousel/index.js';

var fixProps = {
    sectionTitle: 'Don’t just take our word for it',
    items: [
        {
            image: 'https://brandclub.com/feed_p0.png',
            name: 'Brianna L.',
            location: 'Denver, CO',
            testimonial: "\"I've found Brandclub to be a great app for quick and easy cash back. It's great to see the cash quickly increase and the rewards are pretty limitless.\"",
        },
        {
            image: 'https://brandclub.com/feed_p1.png',
            name: 'Karen M.',
            location: 'Seattle, WA',
            testimonial: "\u201CThis is hands down the best rewards app. I can track all my rewards in one place and have earned over $50 in the first week.\u201D",
        },
        {
            image: 'https://brandclub.com/feed_p2.png',
            name: 'Ryan P.',
            location: 'Chicago, IL',
            testimonial: "\"Links directly to my Amazon, Walmart, and Target accounts while seamlessly rewarding me cash back! Pretty sweet and super easy.\"",
        },
    ],
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var BrandclubTestimonialCarousel = function (_a) {
    var baseProps = __rest(_a, []);
    return React.createElement(TextCarousel, __assign({}, fixProps, baseProps));
};

export { BrandclubTestimonialCarousel };
//# sourceMappingURL=index.js.map
